import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { DemoNavbar } from './DemoNavbar';
import { Footer } from './Footer';
import { RequestAccessModal } from './RequestAccessModal';

export function DemoPageWrapper() {
  const [showRequestAccessModal, setShowRequestAccessModal] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // This is now just an informational page - no API calls needed
  }, []);

  return (
    <div className="landing-page">
      {/* Header with Logo */}
      <DemoNavbar />
      
      {/* Hero Section */}
      <div className="landing-hero">
        <div className="hero-content">
          <div className="hero-badge">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M9 12l2 2 4-4"/>
              <path d="M21 12c-1 0-3-1-3-3s2-3 3-3 3 1 3 3-2 3-3 3"/>
              <path d="M3 12c1 0 3-1 3-3s-2-3-3-3-3 1-3 3 2 3 3 3"/>
              <path d="M12 3c0 1-1 3-3 3s-3-2-3-3 1-3 3-3 3 2 3 3"/>
              <path d="M12 21c0-1 1-3 3-3s3 2 3 3-1 3-3 3-3-2-3-3"/>
            </svg>
            <span>What to Expect</span>
          </div>
          <h1 className="hero-title">
            The <span className="transform-text">FREE</span> Sourcing and Hiring <br /> 
            <span className="transform-text">Principal</span> Talent Course <span className="transform-text"> Preview </span>
          </h1>
          <p className="hero-description">
            Not sure yet? You'll get a taste of all 8 modules below - each offering actionable insights, real-world examples, and quick wins to cut time-to-hire and boost response rates.
          </p>
          <p className="hero-description">
            No credit card needed. Just sign up to unlock the full FREE course.
          </p>
          
          <div className="hero-actions">
            <button 
              onClick={() => setShowRequestAccessModal(true)}
              className="btn btn-primary btn-large"
            >
              Start Learning
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M5 12h14m-7-7l7 7-7 7"/>
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* Course Preview Section */}
      <div className="landing-courses">
        <div className="landing-container">

          {/* Course Overview */}
          <div className="section-header">
            <div className="section-badge">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/>
                <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/>
              </svg>
              <span>Course Overview</span>
            </div>
            <div className="section-header-content">
              <div className="section-header-left">
                <h2 className="section-title">
                  What You'll Master in This Course
                </h2>
              </div>
              <div className="section-header-right">
                <p className="section-description">
                  A comprehensive 8-module program designed to transform your recruitment approach and help you successfully source and hire senior IT talent in today's competitive market.
                </p>
              </div>
            </div>
          </div>
          
          <div className="problem-cards">
            <div className="problem-card">
              <div className="problem-title">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10"/>
                  <polyline points="12,6 12,12 16,14"/>
                </svg>
                Duration & Format
              </div>
              <div className="problem-description">
                4-6 hours total (self-paced, 30-60 min per module). Text-based lessons, interactive quizzes, downloadable resources, and simple activities.
              </div>
              <div className="problem-impact">
                <div className="impact-label">Perfect for busy schedules</div>
                <div className="impact-text">Learn at your own pace with bite-sized modules</div>
              </div>
            </div>

            <div className="problem-card">
              <div className="problem-title">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>
                  <circle cx="9" cy="7" r="4"/>
                  <path d="M22 21v-2a4 4 0 0 0-3-3.87"/>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                </svg>
                Target Audience
              </div>
              <div className="problem-description">
                Beginner to intermediate recruiters at startups or mid-sized tech firms.
              </div>
              <div className="problem-impact">
                <div className="impact-label">Tailored for your level</div>
                <div className="impact-text">Whether you're new to recruitment or looking to level up</div>
              </div>
            </div>

            <div className="problem-card">
              <div className="problem-title">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M9 12l2 2 4-4"/>
                  <path d="M21 12c-1 0-3-1-3-3s2-3 3-3 3 1 3 3-2 3-3 3"/>
                  <path d="M3 12c1 0 3-1 3-3s-2-3-3-3-3 1-3 3 2 3 3 3"/>
                  <path d="M12 3c0 1-1 3-3 3s-3-2-3-3 1-3 3-3 3 2 3 3"/>
                  <path d="M12 21c0-1 1-3 3-3s3 2 3 3-1 3-3 3-3-2-3-3"/>
                </svg>
                What You'll Gain
              </div>
              <div className="problem-description">
                Foundational skills to source and hire principal IT talent, addressing CZ's 63% and US's 74% shortages (LinkedIn Talent Trends 2024).
              </div>
              <div className="problem-impact">
                <div className="impact-label">Proven results</div>
                <div className="impact-text">Based on real market data and successful hiring strategies</div>
              </div>
            </div>
          </div>

          <div className="trusted-partners">
            <div className="partners-header">
              <div className="section-badge">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                </svg>
                <span>Bonus Included</span>
              </div>
              <h3>What You Get Extra</h3>
              <p>Optional async feedback on activities, plus a free 30-min audit to identify quick wins for your team</p>
            </div>
          </div>

          {/* Modules */}
          <div className="section-header" style={{ paddingTop: '4rem' }}>
            <div className="section-badge">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M9 11H5a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2h-4"/>
                <rect x="9" y="11" width="6" height="11"/>
                <path d="M9 7h6v4H9z"/>
              </svg>
              <span>Course Modules</span>
            </div>
            <div className="section-header-content">
              <div className="section-header-left">
                <h2 className="section-title">
                  Ready to See What's Inside?
                </h2>
              </div>
              <div className="section-header-right">
                <p className="section-description">
                  Scroll through the modules to spark your curiosity - each teaser highlights key takeaways and resources that'll make you eager to unlock more.
                </p>
              </div>
            </div>
          </div>
          
          <div className="demo-module-cards">
            
            {/* Module 1 */}
            <div className="course-card course-card-free">
              <div className="course-badge">Unlocked</div>
              <div className="course-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M9 12l2 2 4-4"/>
                  <path d="M21 12c-1 0-3-1-3-3s2-3 3-3 3 1 3 3-2 3-3 3"/>
                  <path d="M3 12c1 0 3-1 3-3s-2-3-3-3-3 1-3 3 2 3 3 3"/>
                  <path d="M12 3c0 1-1 3-3 3s-3-2-3-3 1-3 3-3 3 2 3 3"/>
                  <path d="M12 21c0-1 1-3 3-3s3 2 3 3-1 3-3 3-3-2-3-3"/>
                </svg>
              </div>
              <h3 className="course-title">Module 1: Introduction to Principal IT Talent Challenges</h3>
              <p className="course-description">
                Get grounded in the realities of the 2025 IT talent market. We'll explore why senior hires are tougher than ever and how to spot opportunities amid the chaos.
              </p>
              <div className="course-features">
                <div className="feature-item">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="10"/>
                    <polyline points="12,6 12,12 16,14"/>
                  </svg>
                  <span>20 minutes</span>
                </div>
                <div className="feature-item">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                    <polyline points="14,2 14,8 20,8"/>
                    <line x1="16" y1="13" x2="8" y2="13"/>
                    <line x1="16" y1="17" x2="8" y2="17"/>
                    <polyline points="10,9 9,9 8,9"/>
                  </svg>
                  <span>Text + Downloadable Report</span>
                </div>
                <div className="feature-item">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M9 12l2 2 4-4"/>
                    <path d="M21 12c-1 0-3-1-3-3s2-3 3-3 3 1 3 3-2 3-3 3"/>
                    <path d="M3 12c1 0 3-1 3-3s-2-3-3-3-3 1-3 3 2 3 3 3"/>
                    <path d="M12 3c0 1-1 3-3 3s-3-2-3-3 1-3 3-3 3 2 3 3"/>
                    <path d="M12 21c0-1 1-3 3-3s3 2 3 3-1 3-3 3-3-2-3-3"/>
                  </svg>
                  <span>Market insights & real examples</span>
              </div>
              </div>
              <div className="course-cta">
              <button 
                onClick={() => setShowRequestAccessModal(true)}
                  className="btn-full btn-premium"
              >
                Start Module 1 Now
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M5 12h14m-7-7l7 7-7 7"/>
                  </svg>
              </button>
              </div>
            </div>

            {/* Module 2 */}
            <div className="course-card course-card-advanced">
              <div className="course-badge">Unlock After Module 1</div>
              <div className="course-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>
                  <circle cx="9" cy="7" r="4"/>
                  <path d="M22 21v-2a4 4 0 0 0-3-3.87"/>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                </svg>
              </div>
              <h3 className="course-title">Module 2: Defining and Understanding Principal Talent</h3>
              <p className="course-description">
                Discover what truly defines a principal IT pro and how to craft job descriptions that magnetize them. This module flips vague JDs into talent attractors.
              </p>
              <div className="course-features">
                <div className="feature-item">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="10"/>
                    <polyline points="12,6 12,12 16,14"/>
                  </svg>
                  <span>45 minutes</span>
                </div>
                <div className="feature-item">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M9 11H5a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2h-4"/>
                    <rect x="9" y="11" width="6" height="11"/>
                    <path d="M9 7h6v4H9z"/>
                  </svg>
                  <span>Interactive + Worksheet</span>
                </div>
                <div className="feature-item">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M9 12l2 2 4-4"/>
                    <path d="M21 12c-1 0-3-1-3-3s2-3 3-3 3 1 3 3-2 3-3 3"/>
                    <path d="M3 12c1 0 3-1 3-3s-2-3-3-3-3 1-3 3 2 3 3 3"/>
                    <path d="M12 3c0 1-1 3-3 3s-3-2-3-3 1-3 3-3 3 2 3 3"/>
                    <path d="M12 21c0-1 1-3 3-3s3 2 3 3-1 3-3 3-3-2-3-3"/>
                  </svg>
                  <span>Job description templates</span>
              </div>
              </div>
              <div className="course-cta">
              <button 
                onClick={() => navigate('/auth')}
                  className="btn-full"
                disabled
              >
                Preview Locked – Complete Module 1 to Access
              </button>
              </div>
            </div>

            {/* Module 3 */}
            <div className="course-card course-card-premium">
              <div className="course-badge">Locked</div>
              <div className="course-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="11" cy="11" r="8"/>
                  <path d="M21 21l-4.35-4.35"/>
                </svg>
              </div>
              <h3 className="course-title">Module 3: Advanced Sourcing Strategies</h3>
              <p className="course-description">
                Go beyond basic searches to hunt hidden gems. Learn hacker-level tricks to source passive seniors where others fail.
              </p>
              <div className="course-features">
                <div className="feature-item">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="10"/>
                    <polyline points="12,6 12,12 16,14"/>
                  </svg>
                  <span>60 minutes</span>
                </div>
                <div className="feature-item">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M9 11H5a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2h-4"/>
                    <rect x="9" y="11" width="6" height="11"/>
                    <path d="M9 7h6v4H9z"/>
                  </svg>
                  <span>Hands-On + Templates</span>
                </div>
                <div className="feature-item">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M9 12l2 2 4-4"/>
                    <path d="M21 12c-1 0-3-1-3-3s2-3 3-3 3 1 3 3-2 3-3 3"/>
                    <path d="M3 12c1 0 3-1 3-3s-2-3-3-3-3 1-3 3 2 3 3 3"/>
                    <path d="M12 3c0 1-1 3-3 3s-3-2-3-3 1-3 3-3 3 2 3 3"/>
                    <path d="M12 21c0-1 1-3 3-3s3 2 3 3-1 3-3 3-3-2-3-3"/>
                  </svg>
                  <span>Sourcing cheat sheets</span>
              </div>
              </div>
              <div className="course-cta">
              <button 
                onClick={() => navigate('/auth')}
                  className="btn-full"
                disabled
              >
                Preview Locked – Progress Through Previous Modules
              </button>
              </div>
            </div>

            {/* Module 4 */}
            <div className="course-card course-card-premium">
              <div className="course-badge">Locked</div>
              <div className="course-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                </svg>
              </div>
              <h3 className="course-title">Module 4: Employer Branding for Senior Talent</h3>
              <p className="course-description">
                Turn your company into a senior magnet. Optimise your online presence to stand out in crowded markets.
              </p>
              <div className="course-features">
                <div className="feature-item">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="10"/>
                    <polyline points="12,6 12,12 16,14"/>
                  </svg>
                  <span>45 minutes</span>
                </div>
                <div className="feature-item">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M9 11H5a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2h-4"/>
                    <rect x="9" y="11" width="6" height="11"/>
                    <path d="M9 7h6v4H9z"/>
                  </svg>
                  <span>Interactive + Checklist</span>
                </div>
                <div className="feature-item">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M9 12l2 2 4-4"/>
                    <path d="M21 12c-1 0-3-1-3-3s2-3 3-3 3 1 3 3-2 3-3 3"/>
                    <path d="M3 12c1 0 3-1 3-3s-2-3-3-3-3 1-3 3 2 3 3 3"/>
                    <path d="M12 3c0 1-1 3-3 3s-3-2-3-3 1-3 3-3 3 2 3 3"/>
                    <path d="M12 21c0-1 1-3 3-3s3 2 3 3-1 3-3 3-3-2-3-3"/>
                  </svg>
                  <span>Branding audit tools</span>
              </div>
              </div>
              <div className="course-cta">
              <button 
                onClick={() => navigate('/auth')}
                  className="btn-full"
                disabled
              >
                Preview Locked – Progress Through Previous Modules
              </button>
              </div>
            </div>

            {/* Module 5 */}
            <div className="course-card course-card-premium">
              <div className="course-badge">Locked</div>
              <div className="course-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                  <circle cx="9" cy="7" r="4"/>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                </svg>
              </div>
              <h3 className="course-title">Module 5: Screening and Engaging Senior Candidates</h3>
              <p className="course-description">
                Screen like a pro and craft outreach that gets responses. Avoid common traps that scare off top talent.
              </p>
              <div className="course-features">
                <div className="feature-item">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="10"/>
                    <polyline points="12,6 12,12 16,14"/>
                  </svg>
                  <span>60 minutes</span>
                </div>
                <div className="feature-item">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M9 11H5a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2h-4"/>
                    <rect x="9" y="11" width="6" height="11"/>
                    <path d="M9 7h6v4H9z"/>
                  </svg>
                  <span>Hands-On + Templates</span>
                </div>
                <div className="feature-item">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M9 12l2 2 4-4"/>
                    <path d="M21 12c-1 0-3-1-3-3s2-3 3-3 3 1 3 3-2 3-3 3"/>
                    <path d="M3 12c1 0 3-1 3-3s-2-3-3-3-3 1-3 3 2 3 3 3"/>
                    <path d="M12 3c0 1-1 3-3 3s-3-2-3-3 1-3 3-3 3 2 3 3"/>
                    <path d="M12 21c0-1 1-3 3-3s3 2 3 3-1 3-3 3-3-2-3-3"/>
                  </svg>
                  <span>Outreach templates & rubrics</span>
              </div>
              </div>
              <div className="course-cta">
              <button 
                onClick={() => navigate('/auth')}
                  className="btn-full"
                disabled
              >
                Preview Locked – Progress Through Previous Modules
              </button>
              </div>
            </div>

            {/* Module 6 */}
            <div className="course-card course-card-premium">
              <div className="course-badge">Locked</div>
              <div className="course-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>
                  <polyline points="3.27,6.96 12,12.01 20.73,6.96"/>
                  <line x1="12" y1="22.08" x2="12" y2="12"/>
                </svg>
              </div>
              <h3 className="course-title">Module 6: Building a Talent Pipeline</h3>
              <p className="course-description">
                Create a steady flow of seniors ready when you need them. No more reactive scrambling.
              </p>
              <div className="course-features">
                <div className="feature-item">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="10"/>
                    <polyline points="12,6 12,12 16,14"/>
                  </svg>
                  <span>45 minutes</span>
                </div>
                <div className="feature-item">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M9 11H5a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2h-4"/>
                    <rect x="9" y="11" width="6" height="11"/>
                    <path d="M9 7h6v4H9z"/>
                  </svg>
                  <span>Interactive + Template</span>
                </div>
                <div className="feature-item">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M9 12l2 2 4-4"/>
                    <path d="M21 12c-1 0-3-1-3-3s2-3 3-3 3 1 3 3-2 3-3 3"/>
                    <path d="M3 12c1 0 3-1 3-3s-2-3-3-3-3 1-3 3 2 3 3 3"/>
                    <path d="M12 3c0 1-1 3-3 3s-3-2-3-3 1-3 3-3 3 2 3 3"/>
                    <path d="M12 21c0-1 1-3 3-3s3 2 3 3-1 3-3 3-3-2-3-3"/>
                  </svg>
                  <span>Pipeline templates</span>
              </div>
              </div>
              <div className="course-cta">
              <button 
                onClick={() => navigate('/auth')}
                  className="btn-full"
                disabled
              >
                Preview Locked – Progress Through Previous Modules
              </button>
              </div>
            </div>

            {/* Module 7 */}
            <div className="course-card course-card-premium">
              <div className="course-badge">Locked</div>
              <div className="course-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M3 3v18h18"/>
                  <path d="M18.7 8l-5.1 5.2-2.8-2.7L7 14.3"/>
                </svg>
              </div>
              <h3 className="course-title">Module 7: Measuring and Optimising Recruitment Success</h3>
              <p className="course-description">
                Track what works and iterate for peak performance. Turn data into your secret weapon.
              </p>
              <div className="course-features">
                <div className="feature-item">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="10"/>
                    <polyline points="12,6 12,12 16,14"/>
                  </svg>
                  <span>45 minutes</span>
                </div>
                <div className="feature-item">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
                    <line x1="9" y1="9" x2="15" y2="15"/>
                    <line x1="15" y1="9" x2="9" y2="15"/>
                  </svg>
                  <span>Interactive + Dashboard</span>
                </div>
                <div className="feature-item">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M9 12l2 2 4-4"/>
                    <path d="M21 12c-1 0-3-1-3-3s2-3 3-3 3 1 3 3-2 3-3 3"/>
                    <path d="M3 12c1 0 3-1 3-3s-2-3-3-3-3 1-3 3 2 3 3 3"/>
                    <path d="M12 3c0 1-1 3-3 3s-3-2-3-3 1-3 3-3 3 2 3 3"/>
                    <path d="M12 21c0-1 1-3 3-3s3 2 3 3-1 3-3 3-3-2-3-3"/>
                  </svg>
                  <span>Metrics dashboard</span>
              </div>
              </div>
              <div className="course-cta">
              <button 
                onClick={() => navigate('/auth')}
                  className="btn-full"
                disabled
              >
                Preview Locked – Progress Through Previous Modules
              </button>
              </div>
            </div>

            {/* Module 8 */}
            <div className="course-card course-card-premium">
              <div className="course-badge">Locked</div>
              <div className="course-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M9 12l2 2 4-4"/>
                  <path d="M21 12c-1 0-3-1-3-3s2-3 3-3 3 1 3 3-2 3-3 3"/>
                  <path d="M3 12c1 0 3-1 3-3s-2-3-3-3-3 1-3 3 2 3 3 3"/>
                  <path d="M12 3c0 1-1 3-3 3s-3-2-3-3 1-3 3-3 3 2 3 3"/>
                  <path d="M12 21c0-1 1-3 3-3s3 2 3 3-1 3-3 3-3-2-3-3"/>
                </svg>
              </div>
              <h3 className="course-title">Module 8: Q&A and Action Planning</h3>
              <p className="course-description">
                Wrap up with answers to tough questions and a personalised plan. Commit to changes that stick.
              </p>
              <div className="course-features">
                <div className="feature-item">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="10"/>
                    <polyline points="12,6 12,12 16,14"/>
                  </svg>
                  <span>30 minutes</span>
                </div>
                <div className="feature-item">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M9 11H5a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2h-4"/>
                    <rect x="9" y="11" width="6" height="11"/>
                    <path d="M9 7h6v4H9z"/>
                  </svg>
                  <span>Interactive + Action Plan</span>
                </div>
                <div className="feature-item">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M9 12l2 2 4-4"/>
                    <path d="M21 12c-1 0-3-1-3-3s2-3 3-3 3 1 3 3-2 3-3 3"/>
                    <path d="M3 12c1 0 3-1 3-3s-2-3-3-3-3 1-3 3 2 3 3 3"/>
                    <path d="M12 3c0 1-1 3-3 3s-3-2-3-3 1-3 3-3 3 2 3 3"/>
                    <path d="M12 21c0-1 1-3 3-3s3 2 3 3-1 3-3 3-3-2-3-3"/>
                  </svg>
                  <span>Personalised roadmap</span>
              </div>
              </div>
              <div className="course-cta">
              <button 
                onClick={() => navigate('/auth')}
                  className="btn-full"
                disabled
              >
                Preview Locked – Progress Through Previous Modules
              </button>
              </div>
            </div>
          </div>

          {/* Bonus Section */}
          <div className="trusted-partners">
            <div className="partners-header">
              <div className="section-badge">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M9 12l2 2 4-4"/>
                  <path d="M21 12c-1 0-3-1-3-3s2-3 3-3 3 1 3 3-2 3-3 3"/>
                  <path d="M3 12c1 0 3-1 3-3s-2-3-3-3-3 1-3 3 2 3 3 3"/>
                  <path d="M12 3c0 1-1 3-3 3s-3-2-3-3 1-3 3-3 3 2 3 3"/>
                  <path d="M12 21c0-1 1-3 3-3s3 2 3 3-1 3-3 3-3-2-3-3"/>
                </svg>
                <span>Why Start Today</span>
              </div>
              <h3>Why Start This Free Course Today?</h3>
              <p>These modules are built on real successes. You'll walk away with basics that save €15K in fees (or help you fill positions that are tough to hire) and set you up for advanced upgrades.</p>
              <p>Curious yet? Sign up to unlock everything and get optional feedback on your progress.</p>
            </div>
            <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap', marginTop: '2rem' }}>
              <button 
                onClick={() => setShowRequestAccessModal(true)}
                className="btn btn-primary btn-large"
              >
                Start Learning
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M5 12h14m-7-7l7 7-7 7"/>
                </svg>
              </button>
              <button 
                onClick={() => navigate('/')}
                className="btn btn-secondary btn-large"
              >
                Return to Landing Page
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Call to Action */}
      <div className="landing-cta">
        <div className="cta-content">
          <div className="cta-badge">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/>
            </svg>
            <span>Ready to Transform?</span>
          </div>
          
          <h2 className="cta-title">
            <span className="transform-text">Revolutionise</span> Your Recruitment Today
          </h2>
          
          <p className="cta-description">
            Be among the first to access this exclusive knowledge. Built from 20+ years of successful IT recruitment experience, 
            this course shares insider strategies that are rarely available for free.
          </p>
          
          <div className="hero-actions">
            <button 
              onClick={() => setShowRequestAccessModal(true)}
              className="btn btn-primary btn-large"
            >
              Start Free Course
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M5 12h14m-7-7l7 7-7 7"/>
              </svg>
            </button>
            <button 
              onClick={() => navigate('/')}
              className="btn btn-secondary btn-large"
            >
              Back to Home
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* Footer */}
      <Footer />

      {/* Request Access Modal */}
      <RequestAccessModal
        isOpen={showRequestAccessModal}
        onClose={() => setShowRequestAccessModal(false)}
        onSuccess={() => {
          setShowRequestAccessModal(false);
        }}
        title="Start Free Course"
      />

    </div>
  );
}
